import {QuestionersActionType, QuestionersActionTypes} from './types';
import { QuestionerDTO } from "../../sdk";

export const getAllQuestioners = (): QuestionersActionType => ({type: QuestionersActionTypes.GET_ALL_QUESTIONERS});
export const getAllQuestionersSuccess = (payload: QuestionerDTO[]): QuestionersActionType => ({type: QuestionersActionTypes.GET_ALL_QUESTIONERS_SUCCESS, payload});
export const getAllQuestionersFailure = (payload: any): QuestionersActionType => ({type: QuestionersActionTypes.GET_ALL_QUESTIONERS_FAILURE, payload});
